import TitreAnime from './TitreAnime.js'
export default TitreAnime;
